import {
  makeRequired,
  makeStringOnlyNumbers,
  stringValidator,
} from '../../../../../OUI/Inputs';

export const mfaCodeFieldValidator = makeRequired(makeStringOnlyNumbers(stringValidator));
